@if ({ asTeam: asTeam$ | async }; as data) {
  <app-basic-user-picker
    [showAlternateRightHeader]="
      !isCreatingGroup && !isCreatingCase && !isMultipleSelect
    "
    [showAlternateRightContent]="
      !isCreatingGroup && !isCreatingCase && !isMultipleSelect
    "
    [showAlternateRightFooter]="true"
    [hideSearch]="isEnteringDetails"
    [showDisabledSelectedUsers]="!isMultipleSelect"
    [multiple]="multiple"
  >
    @if (data.asTeam) {
      <app-as-team-header
        [name]="data.asTeam.name"
        left-header
      ></app-as-team-header>
    }
    <ng-container left-content>
      <app-network-user-picker-content
        [hidden]="isEnteringDetails"
      ></app-network-user-picker-content>
      @if (isEnteringDetails) {
        <app-new-message-create
          [(name)]="conversationName"
          (nameInvalid)="isConversationNameInvalid = $event"
          [patientData]="patientData"
          [type]="isCreatingGroup ? 'Group' : 'Case'"
        ></app-new-message-create>
      }
    </ng-container>
    <app-conversation-type-buttons
      right-content
    ></app-conversation-type-buttons>
    @if (isCreatingGroup || isCreatingCase || isMultipleSelect) {
      <ng-container right-footer>
        <button
          mat-button
          class="celo-primary-button uppercase"
          (click)="handleSubmit()"
          [disabled]="isEnteringDetails && isConversationNameInvalid"
        >
          {{ submitButtonText || "Continue" }}
        </button>
        <button
          mat-button
          class="celo-secondary-button uppercase"
          (click)="handleBack()"
        >
          {{ cancelButtonText || "Back" }}
        </button>
      </ng-container>
    }
  </app-basic-user-picker>
}
